export default "__VITE_ASSET__dfea82fc__"